<template>
  <footer class="auth-brand-footer" :class="{ 'auth-brand-footer--fixed': fixed }">
    <p class="auth-brand-footer__text">
      <strong>رو ب رو</strong>
      <span class="auth-brand-footer__sep">|</span>
      پلتفرم تخصصی مشاوره آنلاین روانشناسی
    </p>
  </footer>
</template>

<script>
export default {
  name: 'AuthBrandFooter',
  props: {
    fixed: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>
.auth-brand-footer {
  width: 100%;
  background: var(--rb-cream, #faf8f4);
  border-top: 1px solid var(--rb-line-soft, #ebe7df);
  padding: 18px 20px;
  direction: rtl;
  text-align: center;
  box-sizing: border-box;
}

.auth-brand-footer--fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.auth-brand-footer__text {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: var(--rb-muted, #627985);
  font-family: var(--rb-font, inherit);
}

.auth-brand-footer__text strong {
  font-weight: 700;
  color: var(--rb-navy, #09364b);
}

.auth-brand-footer__sep {
  margin: 0 10px;
  color: var(--rb-line, #d8d2c6);
  font-weight: 400;
}
</style>
